var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrice3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "startup") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Personal-1-mixed",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1165.000000, -3882.000000)",
    fillRule: "nonzero",
    id: "price"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(350.000000, 3692.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-copy-11",
    transform: "translate(690.000000, 159.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "startup",
    transform: "translate(165.000000, 71.000000) scale(-1, 1) translate(-165.000000, -71.000000) translate(125.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.8370824,48.9441965 L48.7804878,48.7804878 L48.9441965,54.8370824 C49.1079052,64.6586635 57.292556,72.6796057 67.1141371,73.007023 L73.1707317,73.1707317 L73.007023,67.1141371 C72.679449,57.292556 64.6585068,49.1079052 54.8370824,48.9441965 Z",
    id: "Path",
    fill: "#F8B64C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9500284,52.8470642 L52.6829268,52.6829268 L52.8470642,56.9500284 C53.0112017,64.007309 58.9195203,69.9156276 65.9768009,70.079765 L70.2439024,70.2439024 L70.079765,65.9768009 C69.9156276,58.9195203 64.0071519,53.0112017 56.9500284,52.8470642 Z",
    id: "Path",
    fill: "#FFD15C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9762481,48.4544661 C79.1445378,46.9534402 77.9799206,45.6192127 76.8154626,44.4516239 C73.821051,41.4495722 70.1611439,39.4481511 66.168489,38.4475204 C58.6824601,36.6128977 50.3645617,38.6143187 44.5419532,44.4516239 C38.7193447,50.2889291 36.7231765,58.6280506 38.5531301,66.1333396 C39.5512142,69.9693834 41.5475416,73.8052675 44.5419532,76.8073193 C45.7064112,77.9747484 47.203617,79.1423372 48.5346081,79.9761695 C39.883962,80.3097663 30.9007272,77.1409161 24.2464085,70.4696189 C18.9229217,65.1325493 15.9285101,58.6280506 14.930426,51.789955 C13.5995941,41.9498077 16.7603796,31.7760636 24.2464085,24.2709341 C31.7324375,16.7658047 42.0466633,13.5969545 51.6953936,14.931182 C58.5160862,15.9318127 65.1704049,18.9340241 70.3275178,24.2709341 C77.1482104,30.7755925 80.3089959,39.7819075 79.9762481,48.4544661 Z",
    id: "Path",
    fill: "#FF4C60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3658537,48.4498426 C60.7222832,20.0908437 36.3434195,-0.805302595 6.15997368,0.0238327193 L0.189691525,0.189691525 L0.0238327193,6.15997368 C-0.805302595,36.3434195 20.0908437,60.7222832 48.4498426,65.3658537 L65.3658537,48.4498426 Z",
    id: "Path",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#454360"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5866975,61.6933081 C39.7411667,63.351094 44.0619928,64.5114966 48.5488576,65.3404689 L65.3332503,48.5968151 C64.6684588,44.1208406 63.3390351,39.810502 61.6772156,35.6661165 L35.5866975,61.6933081 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9481764,2.67635094 C19.799492,0.852770542 13.1522141,-0.141996211 6.1725405,0.0237982477 L0.190054003,0.189592707 L0.023856151,6.15755861 C-0.142341701,13.1202913 0.854686369,19.751435 2.6827037,25.8851954 L25.9481764,2.67635094 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.7804878,65.6724068 C50.4529693,66.0069351 52.2927149,66.1741993 53.9651964,66.3414634 L66.3414634,53.9651964 C66.1741993,52.1254508 66.0069351,50.4529693 65.6724068,48.7804878 L48.7804878,65.6724068 Z",
    id: "Path",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#454360",
    cx: 28.2926829,
    cy: 28.2926829,
    r: 12.6829268
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#6C6CE5",
    cx: 28.2926829,
    cy: 28.2926829,
    r: 8.7804878
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.738439,23.1571229 C25.8422306,19.9935576 30.7429789,19.9935576 33.8467705,23.1571229 C36.7871882,26.154168 36.9505621,30.9827761 34.1735183,34.1463415 C34.3368922,33.9798213 34.5002662,33.9798213 34.5002662,33.813301 C37.9308056,30.3166953 37.9308056,24.6556455 34.5002662,21.1590397 C31.0697267,17.6624339 25.5156391,17.6624339 22.0850997,21.1590397 C18.6545603,24.6556455 18.6545603,30.3166953 22.0850997,33.813301 C22.2484736,33.9798213 22.4118475,33.9798213 22.4118475,34.1463415 C19.7980213,30.9827761 19.7980213,26.154168 22.738439,23.1571229 Z",
    id: "Path",
    fill: "#6C6CE5"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice3);
export default __webpack_public_path__ + "static/media/price-3.e38b12b9fc0ac74980f5c43d470782e0.svg";
export { ForwardRef as ReactComponent };